import type { ReactNode } from 'react'

import { useTheme } from '@emotion/react'

import * as styles from './headline.styles'
import { SizeProvider } from './size-context'

export type Align = 'start' | 'center'
export type HeadlineSize = 'default' | 'large' | 'xl'

type Props = {
  children: ReactNode
  align?: Align
  size?: HeadlineSize
  className?: string
  noTopMargin?: boolean
  fullWidth?: boolean
}

export const Headline = ({
  children,
  align = 'center',
  size = 'default',
  className,
  noTopMargin = false,
  fullWidth = false,
}: Props) => {
  const theme = useTheme()

  return (
    <header
      className={className}
      css={[
        styles.container,
        styles.align[align],
        !noTopMargin && styles.topMargin(theme),
        fullWidth && styles.fullWidth,
      ]}
      data-testid="headline"
    >
      <SizeProvider size={size}>{children}</SizeProvider>
    </header>
  )
}
